import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

export const delayedEventsSupportedAtom = atom(false);

export const getScheduledMessageStateKey = (userId: string, roomId: string): string =>
  `${userId}\0${roomId}`;

export const roomIdToScheduledTimeAtomFamily = atomFamily<
  string,
  ReturnType<typeof atom<Date | null>>
>(() => atom<Date | null>(null));

// Save the delay_id instead of cancelling the message immediately in case
// the edit process is cancelled
export const roomIdToEditingScheduledDelayIdAtomFamily = atomFamily<
  string,
  ReturnType<typeof atom<string | null>>
>(() => atom<string | null>(null));

export const serverMaxDelayMsAtom = atom<number | null>(null);
